import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@mui/material';


const DeleteTimesheet = ({
    timesheetDelete,
    closeModalTimesheetDelete,
    setJustificationDelete,
    deleteTimesheet,
    handleMenuCloseAtividade,
    setMenuTimesheet,
    startLoading
}) => {
    const [disabled, setDisabled] = useState(false)
    const [messageDisabled, setMessageDisabled] = useState('')
    const [justification, setJustification] = useState('')

    const handleJustificationChange = (e) => {
        const value = e.target.value;
        if (!value) {
            return setMessageDisabled('O campo Justificativa é obrigatório.');
        }
        setDisabled(false)
        setMessageDisabled('')
        setJustificationDelete(value);
        setJustification(value)
    };

    const handleClick = () => {
        if (!justification) {
            setDisabled(true)
            return setMessageDisabled('O campo Justificativa é obrigatório.')
        }
        setDisabled(false)
        setMessageDisabled('')
        setJustification('')
        deleteTimesheet()
        closeModalTimesheetDelete()
        setMenuTimesheet(false)
        startLoading('Excluindo')
    }

    return (

        <Dialog
            open={timesheetDelete}
            onClose={closeModalTimesheetDelete}
            maxWidth="md"
            PaperProps={{ style: styles.dialog }}
            scroll='paper'
        >
            <DialogTitle style={styles.title}>
                Informe o motivo da exclusão do ponto.
            </DialogTitle>

            <DialogContent style={styles.content}>
                <TextField
                    id="outlined-basic"
                    label="Justificativa"
                    variant="outlined"
                    sx={{ "& .MuiOutlinedInput-notchedOutline": { borderTop: "none", borderLeft: "none", borderRight: "none" } }}
                    style={styles.textField}
                    onBlur={handleJustificationChange}
                />
                <Typography style={styles.typography}>
                    {messageDisabled}
                </Typography>
                <Grid style={styles.grid}>
                    <Button
                        onClick={handleClick}
                        variant="contained"
                        style={styles.confirmButton}
                        disabled={disabled}
                    >
                        Confirmar
                    </Button>
                    <Button
                        variant="contained"
                        style={styles.closeButton}
                        onClick={closeModalTimesheetDelete}
                    >
                        Fechar
                    </Button>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

export default DeleteTimesheet;

const styles = {
    dialog: {
        backgroundColor: 'white',
        borderRadius: '20px',
        width: '600px',
        height: '350px'
    },
    title: {
        fontSize: '22px',
        marginTop: '4%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    content: { marginLeft: '3%', marginTop: '5%' },
    textField: { width: '96%', marginTop: '5%' },
    typography: { marginLeft: '2%', marginTop: '2%', color: 'red' },
    grid: { display: 'flex' },
    confirmButton: {
        backgroundColor: '#4851de',
        color: 'white',
        borderRadius: '20px',
        marginLeft: '10.5%',
        height: '50px',
        marginTop: '6%',
        width: '35%'
    },
    closeButton: {
        backgroundColor: 'white',
        color: '#4851de',
        borderRadius: '20px',
        marginLeft: '1.5%',
        height: '50px',
        marginTop: '6%',
        width: '35%',
        border: '1px solid #4851de'
    }
};